import React, { PropTypes } from 'react';
import styles from './styles.scss';


export const Label = (props) => {
  const { className, label, ...other } = props;
  return (
    <label {...other} className={[className, styles.label].join(' ').trim()}>
      {label}
    </label>
  );
};


Label.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
};


export default Label;



// WEBPACK FOOTER //
// ./src/components/sign_up/shared/label/index.jsx